export const getModuleOptionsInterface = () => ({
  cardSelector: null, // селектор карточки врача
  doctorPageType: null, // тип страницы с врачами - страница списка врачей или страница врача. От этого зависит используемое пространство имен
  hookTabChange: () => {}, // хук, который будет срабатывать при изменении таба типа приема
  hookOptionClick: () => {}, // хук, который будет срабатывать при клике на опцию 'select' при выборе 'workplace'
})
